<template>
	<div>
		<!-- Political Parties Stats -->
		<div v-if="response.parties" class="row mb-4">
			<div class="col-12">
				<div class="card">
					<div
						class="card-header py-3 d-flex flex-row align-items-center justify-content-between"
					>
						<h6 class="m-0 font-weight-bold text-primary">
							<i data-feather="flag" class="me-1"></i>
							Political Parties Statistics
						</h6>
					</div>
					<div class="card-body">
						<div class="row">
							<!-- Total Registered -->
							<router-link
								:to="{ name: 'RegisteredPartiesList' }"
								class="col-xl-4 col-md-6 mb-4"
							>
								<div class="card stat-card primary">
									<div class="card-body">
										<div class="row no-gutters align-items-center">
											<div class="col me-2">
												<h6
													class="font-weight-bold text-primary text-uppercase mb-1"
												>
													Total Registered
												</h6>
												<div class="h5 mb-0 font-weight-bold text-gray-800">
													{{ response.parties.total_registered }}
												</div>
											</div>
											<div class="col-auto">
												<i
													class="feather icon-check-circle text-primary"
													style="width: 2.5rem; height: 2.5rem"
												></i>
											</div>
										</div>
									</div>
								</div>
							</router-link>

							<!-- Total De-Registered -->
							<div class="col-xl-4 col-md-6 mb-4">
								<div class="card stat-card danger">
									<div class="card-body">
										<div class="row no-gutters align-items-center">
											<div class="col me-2">
												<h6
													class="font-weight-bold text-danger text-uppercase mb-1"
												>
													Total De-Registered
												</h6>
												<div class="h5 mb-0 font-weight-bold text-gray-800">
													{{ response.parties.total_de_registered }}
												</div>
											</div>
											<div class="col-auto">
												<i
													class="feather icon-x-circle text-danger"
													style="width: 2.5rem; height: 2.5rem"
												></i>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- Total Intending -->
							<router-link
								:to="{ name: 'IntendingPartiesList' }"
								class="col-xl-4 col-md-6 mb-4"
							>
								<div class="card stat-card warning">
									<div class="card-body">
										<div class="row no-gutters align-items-center">
											<div class="col me-2">
												<h6
													class="font-weight-bold text-warning text-uppercase mb-1"
												>
													Total Interest
												</h6>
												<div class="h5 mb-0 font-weight-bold text-gray-800">
													{{ response.parties.total_intended }}
												</div>
											</div>
											<div class="col-auto">
												<i
													class="feather icon-clock text-warning"
													style="width: 2.5rem; height: 2.5rem"
												></i>
											</div>
										</div>
									</div>
								</div>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Intending/Association Stats -->
		<div v-if="response.applications" class="row">
			<div class="col-12">
				<div class="card">
					<div
						class="card-header py-3 d-flex flex-row align-items-center justify-content-between"
					>
						<h6 class="m-0 font-weight-bold text-info">
							<i class="feather icon-users me-1"></i>
							Intending/Association Statistics
						</h6>
					</div>
					<div class="card-body">
						<div class="row">
							<!-- Total Pending -->
							<div class="col-xl-3 col-md-6 mb-4">
								<div class="card stat-card warning">
									<div class="card-body">
										<div class="row no-gutters align-items-center">
											<div class="col me-2">
												<h6
													class="font-weight-bold text-warning text-uppercase mb-1"
												>
													Total Application<br />
													Code Sent
												</h6>
												<div class="h5 mb-0 font-weight-bold text-gray-800">
													{{ response?.applications.total_code }}
												</div>
											</div>
											<div class="col-auto">
												<i
													class="feather icon-clock text-warning"
													style="width: 2.5rem; height: 2.5rem"
												></i>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- Total In-Progress -->
							<div class="col-xl-3 col-md-6 mb-4">
								<div class="card stat-card primary">
									<div class="card-body">
										<div class="row no-gutters align-items-center">
											<div class="col me-2">
												<h6
													class="font-weight-bold text-primary text-uppercase mb-1"
												>
													Total Application<br />
													In-Progress
												</h6>
												<div class="h5 mb-0 font-weight-bold text-gray-800">
													{{ response?.applications.total_in_progress }}
												</div>
											</div>
											<div class="col-auto">
												<i
													class="feather icon-refresh-cw text-primary"
													style="width: 2.5rem; height: 2.5rem"
												></i>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- Total Completed -->
							<div class="col-xl-3 col-md-6 mb-4">
								<div class="card stat-card success">
									<div class="card-body">
										<div class="row no-gutters align-items-center">
											<div class="col me-2">
												<h6
													class="font-weight-bold text-success text-uppercase mb-1"
												>
													Total Application<br />
													Completed
												</h6>
												<div class="h5 mb-0 font-weight-bold text-gray-800">
													{{ response?.applications.total_completed }}
												</div>
											</div>
											<div class="col-auto">
												<i
													class="feather icon-check-circle text-success"
													style="width: 2.5rem; height: 2.5rem"
												></i>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- Total Applications -->
							<div class="col-xl-3 col-md-6 mb-4">
								<div class="card stat-card danger">
									<div class="card-body">
										<div class="row no-gutters align-items-center">
											<div class="col me-2">
												<h6
													class="font-weight-bold text-danger text-uppercase mb-1"
												>
													Total Application<br />
													Rejected
												</h6>
												<div class="h5 mb-0 font-weight-bold text-gray-800">
													{{ response?.applications.total_rejected }}
												</div>
											</div>
											<div class="col-auto">
												<i
													class="feather icon-file-text text-danger"
													style="width: 2.5rem; height: 2.5rem"
												></i>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Progress Chart -->
		<div class="row mt-4">
			<div class="col-lg-8 mb-4">
				<div class="card shadow mb-4">
					<div
						class="card-header py-3 d-flex flex-row align-items-center justify-content-between"
					>
						<h6 class="m-0 font-weight-bold text-primary">
							<i data-feather="activity" class="me-1"></i>
							Recent Applications
						</h6>
					</div>
					<div class="card-body">
						<div
							v-if="response.recent_applications"
							class="list-group list-group-flush"
						>
							<div
								v-for="application in response.recent_applications"
								class="list-group-item list-group-item-action"
								:key="application.id"
							>
								<div class="d-flex w-100 justify-content-between">
									<h6 class="mb-1" :class="getStatusBadge(application.status)">
										New Registration
									</h6>
									<small class="text-muted">{{
										application.applied_date
									}}</small>
								</div>
								<p class="mb-1">
									{{ application.description }} Submitted an Application
								</p>
								<small class="text-muted"
									>Status:
									<span :class="getStatusBadge(application.status)">{{
										application.status
									}}</span></small
								>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-4 mb-4">
				<div class="card shadow">
					<div
						class="card-header py-3 d-flex flex-row align-items-center justify-content-between"
					>
						<h6 class="m-0 font-weight-bold text-primary">
							Party Distribution
						</h6>
					</div>
					<div class="card-body">
						<div class="chart-pie pt-4 pb-2">
							<div id="partyPieChart" style="height: 280px; width: 100%"></div>
						</div>
						<div class="mt-4 text-center small">
							<span class="me-2">
								<i class="fas fa-circle text-primary"></i>
								Registered
							</span>
							<span class="me-2">
								<i class="fas fa-circle text-warning"></i>
								Intending
							</span>
							<span class="me-2">
								<i class="fas fa-circle text-danger"></i>
								De-Registered
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
var Highcharts = require("highcharts");

export default {
	computed: {
		...mapGetters({
			user: "auth/currentUser",
			response: "dashboard/response",
		}),
	},
	methods: {
		getStatusBadge(status) {
			if (status.toLowerCase() == "intended") {
				return "text-warning";
			}

			if (status.toLowerCase() == "in_progress") {
				return "text-primary";
			}

			return "text-success";
		},

		async getDashboardData() {
			await this.$store
				.dispatch("dashboard/getPartyDashboardData")
				.then((response) => {
					this.plotHightChart(response);
				});
		},
		plotHightChart(response) {
			Highcharts.chart("partyPieChart", {
				chart: {
					type: "pie",
					backgroundColor: null,
				},
				title: {
					text: null,
				},
				plotOptions: {
					pie: {
						innerSize: "70%",
						dataLabels: {
							enabled: false,
							format: "<b>{point.name}</b>: {point.y}",
						},
						borderColor: null,
					},
				},
				legend: {
					enabled: false,
				},
				series: [
					{
						name: "Parties",
						colorByPoint: true,
						data: [
							{
								name: "Registered",
								y: response?.parties.total_registered,
								color: "rgba(78, 115, 223, 0.8)",
							},
							{
								name: "Intending",
								y: response?.parties.total_intended,
								color: "rgba(246, 194, 62, 0.8)",
							},
							{
								name: "De-Registered",
								y: response?.parties.total_de_registered,
								color: "rgba(231, 74, 59, 0.8)",
							},
						],
					},
				],
			});
		},
	},

	mounted() {
		this.getDashboardData();
	},
};
</script>

<style scoped>
.card {
	border: none;
	border-radius: 0.35rem;
	box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
}

.card-header {
	background-color: #f8f9fc;
	border-bottom: 1px solid #e3e6f0;
}

.stat-card {
	border-left: 0.25rem solid;
	transition: transform 0.3s;
}

.stat-card:hover {
	transform: translateY(-5px);
}

.stat-card.primary {
	border-left-color: #29623c !important;
}

.stat-card.success {
	border-left-color: #1cc88a !important;
}

.stat-card.info {
	border-left-color: #36b9cc !important;
}

.stat-card.warning {
	border-left-color: #f6c23e !important;
}

.stat-card.danger {
	border-left-color: #e74a3b !important;
}

.stat-card .card-body {
	padding: 1rem 1.5rem !important;
}

.stat-card .text-xs {
	font-size: 0.7rem !important;
	text-transform: uppercase;
	letter-spacing: 0.1em;
}

.stat-card .text-primary {
	color: #29623c !important;
}

.stat-card .text-success {
	color: #1cc88a !important;
}

.stat-card .text-info {
	color: #36b9cc !important;
}

.stat-card .text-warning {
	color: #f6c23e !important;
}

.stat-card .text-danger {
	color: #e74a3b !important;
}

.progress-sm {
	height: 0.5rem !important;
}

.chart-area {
	position: relative;
	height: 10rem;
	width: 100%;
}

h6 {
	font-size: 1rem !important;
}

.feather {
	font-size: 2rem !important;
}
</style>
